import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["rename", "keyname", "visible", "children"];
import React, { memo, useEffect } from 'react';
import { useStore } from "./store.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var Textarea = /*#__PURE__*/memo(props => {
  var {
    fields = {},
    extra = {},
    $$index = {},
    dispatch
  } = useStore();
  useEffect(() => {
    var {
        rename,
        keyname,
        visible = true,
        children
      } = props,
      elmProps = _objectWithoutPropertiesLoose(props, _excluded);
    if (keyname || elmProps.name) {
      var key = keyname || elmProps.name;
      delete fields[key];
      delete extra[key];
      delete $$index[key];
      dispatch({
        $$index: _extends({}, $$index, {
          [key]: elmProps.index || 0
        }),
        extra: _extends({}, extra, {
          [key]: children || null
        }),
        fields: _extends({}, fields, {
          [key]: visible ? /*#__PURE__*/_jsx("textarea", _extends({}, elmProps, {
            name: rename || elmProps.name
          })) : null
        })
      });
    }
  }, [props]);
  return null;
});
Textarea.displayName = 'Login.Textarea';